/*!
 *  6/18/2018, 11:14:12 AM
 *  Copyright 2018 FT, DK Techin Corp 
 */
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _videoClip = __webpack_require__(5);
	
	var _videoClip2 = _interopRequireDefault(_videoClip);
	
	var _useTimeMachine = __webpack_require__(4);
	
	var _useTimeMachine2 = _interopRequireDefault(_useTimeMachine);
	
	var _realtimeWatch = __webpack_require__(2);
	
	var _realtimeWatch2 = _interopRequireDefault(_realtimeWatch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
	
	var timeMachine = (0, _useTimeMachine2["default"])('EPT', function (storedState) {
	  setState(storedState);
	});
	
	var $ctx = (0, _jquery2["default"])('#eptColl');
	var $mainTabWrap = $ctx.find('.tab_rwd.tab_rwd_box');
	var $listTab = $mainTabWrap.find('.list_tab');
	var $listTabItems = $listTab.children(); // li
	var $mainPanels = $ctx.find('.coll_cont .tab_body .cont_wrap');
	
	var state = {
	  tabIdx: 0,
	  tabName: ''
	};
	
	render(MainTab(state), MainPanel(state));
	setToolTip();
	setInitialState();
	initCountDownTimer($ctx);
	togglePanelsOnTabClick();
	moreScoreView();
	setVClip();
	setVClipList();
	timeMachine.check();
	
	/**
	 * 야구에서만 사용됩니다.
	 * 경기결과가 9회차 이상인 경우에만 페이지를 넘기도록 하는 함수.
	 * 담당자 : @rain
	 * > 테이블의 td 를 넘길 수 있다.
	 * > 스포츠 1차 개편의 시안과 2차 개변의 시안이 상이하여 사용될지는 미지수.
	 */
	function moreScoreView() {
	  var $tblBaseBall = $ctx.find('.tbl_baseball');
	  var $nextBtn = $tblBaseBall.find('.btn_score_r');
	  var $prevBtn = $tblBaseBall.find('.btn_score_l');
	  var $innigScore = $tblBaseBall.find('thead th');
	  var inningAllScore = $innigScore.length - 4; //allScore - R/H/S
	  var $inning = $tblBaseBall.find('tbody tr');
	  var $homeInnig = $inning.eq(0).find('td');
	  var $awayInnig = $inning.eq(1).find('td');
	  var $scoreNum = $innigScore.slice(1, inningAllScore + 1); //<th> slice tit,R/H/s
	  var $homeScoreNum = $homeInnig.slice(1, inningAllScore + 1); //<td> slice tit,R/H/s
	  var $awayScoreNum = $awayInnig.slice(1, inningAllScore + 1); //<td> slice tit,R/H/s
	
	  function sliceNum(sliceElem) {
	    var sliceNum = 9; //chunk num = show
	    var startCurrentNum = -9; //start idx (-n : start lastNum)
	    var displaySelector = void 0; //selector.slice( startIdx, endIdx )
	    var startIdx = void 0;
	    var endIdx = void 0;
	    var $scoreNum = sliceElem;
	
	    function clickToggleClass() {
	      $scoreNum.addClass('hide');
	      displaySelector.removeClass('hide');
	      startCurrentNum = startIdx;
	    }
	
	    function whenTargetLowerSliceNum(start, end) {
	      endIdx = startIdx + sliceNum;
	      displaySelector = $scoreNum.slice(startIdx, endIdx);
	
	      if (displaySelector.length < sliceNum) {
	        startIdx = start;
	        endIdx = end;
	        displaySelector = $scoreNum.slice(start, end);
	      }
	    }
	
	    function changeBtnClass() {
	      if (inningAllScore === sliceNum) {
	        $prevBtn.addClass('left_off');
	        $nextBtn.addClass('right_off');
	      }
	
	      if (!$innigScore.eq(1).hasClass('hide')) {
	        $prevBtn.addClass('left_off');
	        $nextBtn.removeClass('right_off');
	      } else if (!$innigScore.eq(inningAllScore).hasClass('hide')) {
	        $nextBtn.addClass('right_off');
	        $prevBtn.removeClass('left_off');
	      } else {
	        $nextBtn.removeClass('right_off');
	        $prevBtn.removeClass('left_off');
	      }
	    }
	
	    changeBtnClass();
	
	    function moreViewPrev() {
	      startIdx = startCurrentNum - sliceNum;
	
	      whenTargetLowerSliceNum(0, sliceNum);
	      clickToggleClass();
	      changeBtnClass();
	    }
	
	    function moreViewNext() {
	      var lastTargetDoneMove = $scoreNum.last().hasClass('hide');
	      if (!lastTargetDoneMove) {
	        $prevBtn.removeClass('left_off');
	        return false;
	      }
	      startIdx = startCurrentNum + sliceNum;
	      whenTargetLowerSliceNum(-sliceNum, $scoreNum.length);
	      clickToggleClass();
	      changeBtnClass();
	    }
	
	    $prevBtn.on('click', moreViewPrev);
	    $nextBtn.on('click', moreViewNext);
	  }
	
	  sliceNum($scoreNum);
	  sliceNum($homeScoreNum);
	  sliceNum($awayScoreNum);
	}
	
	function setState(newState) {
	  _jquery2["default"].extend(state, newState);
	  (0, _jquery2["default"])(state).trigger('update');
	}
	
	function setInitialState() {
	  setState({ tabIdx: $listTabItems.filter('.on').index() });
	}
	
	function togglePanelsOnTabClick() {
	  $listTab.on('click', 'li', function () {
	    var $this = (0, _jquery2["default"])(this);
	    setState({ tabIdx: $this.index() });
	  });
	}
	
	function render() {
	  for (var _len = arguments.length, fns = Array(_len), _key = 0; _key < _len; _key++) {
	    fns[_key] = arguments[_key];
	  }
	
	  (0, _jquery2["default"])(state).on('update', function () {
	    fns.forEach(function (fn) {
	      return fn();
	    });
	    timeMachine.storage.set(state);
	  });
	}
	
	function setVClipList() {
	  var $highlightListType = $ctx.find('.highlight_cont.list_type');
	  if ($highlightListType.length > 0) {
	    new _videoClip2["default"]({
	      listSelector: '.highlight_cont.list_type',
	      $context: $ctx,
	      rendingType: 'inner-list', //외부 렌더링시 basic 내부 삽입시 inner-list
	      rowCount: 3,
	      vclipSelector: '_vClipBox_list', // 이것으로 아이디가 생성됩니다 # 포함 금지
	      removeSelector: '.video_player'
	    });
	  }
	}
	function setVClip() {
	  var $highlightListType = $ctx.find('.highlight_cont:not(.list_type)');
	  if ($highlightListType.length > 0) {
	    new _videoClip2["default"]({
	      listSelector: '.highlight_cont:not(.list_type)',
	      $context: $ctx
	    });
	  }
	}
	
	function initCountDownTimer($ctx) {
	  if (!($ctx.find('.cont_worldcup').length > 0)) {
	    return;
	  }
	  if (!($ctx.find('.play_season .match_score').length > 0)) {
	    return;
	  }
	  var $target = $ctx.find('.match_score');
	  var startTime = ('' + $target.data('starttime')).slice(0, 14);
	  var $timeIndicator = $target.find('.txt_time');
	
	  if (typeof startTime !== 'string' || startTime.length !== 14) {
	    return;
	  }
	
	  var countdownWatch = new _realtimeWatch2["default"](startTime, function (diff) {
	    if (diff.reduce(function (a, b) {
	      return a + b;
	    }) <= 0) {
	      countdownWatch.stop();
	      $timeIndicator.text('00:00:00');
	    } else {
	      $timeIndicator.text(diff.map(_realtimeWatch2["default"].addZero).join(':'));
	    }
	  });
	
	  countdownWatch.start();
	
	  return countdownWatch;
	}
	
	function setToolTip() {
	  if (!($ctx.find('.info_adsch.info_fairtrade').length > 0)) {
	    return;
	  }
	  var $toolTip = $ctx.find('.info_adsch.info_fairtrade');
	
	  $toolTip.on('click', '.ico_rwd.ico_help', function () {
	    $toolTip.find('.layer_ad').toggleClass('on');
	  });
	
	  $toolTip.on('click', '.btn_close', function () {
	    $toolTip.find('.layer_ad.on').removeClass('on');
	  });
	}
	
	// UI Components
	function MainTab(state) {
	  return function () {
	    $listTabItems.removeClass('on');
	    $listTabItems.eq(state.tabIdx).addClass('on');
	  };
	}
	
	function MainPanel(state) {
	  return function () {
	    $mainPanels.addClass('hide');
	    $mainPanels.eq(state.tabIdx).removeClass('hide');
	  };
	}

/***/ },
/* 1 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function RealTimeWatch(gameStartsAt, callback) {
	  this.gameStartsAt = RealTimeWatch.parse(gameStartsAt).getTime();
	  this.serverTime = RealTimeWatch.getClientTime();
	  this.callback = callback;
	  this.diff = this.toRemainingTimeArr();
	  this.timer = -1;
	}
	
	// Static Methods
	_jquery2['default'].extend(RealTimeWatch, {
	  getClientTime: function getClientTime() {
	    return RealTimeWatch.parse(window.ServerTime);
	  },
	  parse: function parse(yyyyMMddHHmmss) {
	    var y = yyyyMMddHHmmss.slice(0, 4);
	    var mIdx = Number(yyyyMMddHHmmss.slice(4, 6)) - 1;
	    var d = yyyyMMddHHmmss.slice(6, 8);
	    var h = yyyyMMddHHmmss.slice(8, 10);
	    var m = yyyyMMddHHmmss.slice(10, 12);
	    var s = yyyyMMddHHmmss.slice(12);
	    return new Date(y, mIdx, d, h, m, s);
	  },
	  addZero: function addZero(num) {
	    return '' + (num < 10 ? '0' + num : num);
	  },
	  getYMDLongArray: function getYMDLongArray(ms) {
	    var d = new Date(ms);
	    return [d.getFullYear(), d.getMonth() + 1, d.getDay(), d.getHours(), d.getMinutes(), d.getSeconds()];
	  },
	  toYMDLongString: function toYMDLongString(ms) {
	    return RealTimeWatch.getYMDLongArray(ms).map(RealTimeWatch.addZero).join('');
	  },
	  toYMDShortString: function toYMDShortString(ms) {
	    return RealTimeWatch.getYMDLongArray(ms).slice(0, 3).map(RealTimeWatch.addZero).join('');
	  }
	});
	
	RealTimeWatch.prototype = {
	  updateServerTime: function updateServerTime() {
	    this.serverTime.setSeconds(this.serverTime.getSeconds() + 1);
	  },
	  getDiff: function getDiff() {
	    return this.gameStartsAt - this.serverTime.getTime();
	  },
	  toRemainingTimeArr: function toRemainingTimeArr() {
	    var min = 1000 * 60 * 60;
	    var sec = 1000 * 60;
	    var diff = this.getDiff();
	
	    var h = diff % (min * 24) / min;
	    var m = diff % min / sec;
	    var s = diff % sec / 1000;
	
	    return [h, m, s].map(Math.floor);
	  },
	  stop: function stop() {
	    clearInterval(this.timer);
	    this.timer = -1;
	  },
	  start: function start() {
	    var _this = this;
	
	    if (this.timer > -1) {
	      return;
	    }
	    this.timer = setInterval(function () {
	      _this.onTick();
	    }, 1000);
	  },
	  onTick: function onTick() {
	    this.updateServerTime();
	    this.diff = this.toRemainingTimeArr();
	    this.callback(this.diff);
	  }
	};
	
	exports['default'] = RealTimeWatch;

/***/ },
/* 3 */
/***/ function(module, exports) {

	'use strict';
	
	exports.__esModule = true;
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var Storage = function Storage(key) {
	  return {
	    get: function get() {
	      return JSON.parse(sessionStorage.getItem(key));
	    },
	    set: function set(value) {
	      var val = value !== null && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' ? JSON.stringify(value) : value;
	      sessionStorage.setItem(key, val);
	    }
	  };
	};
	
	exports['default'] = Storage;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _storage = __webpack_require__(3);
	
	var _storage2 = _interopRequireDefault(_storage);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	function useTimeMachine(displayCode, onBack) {
	  var performance = window.performance || {};
	  var nav = performance.navigation || {};
	  var isBackButton = nav.type === 2;
	  var storage = (0, _storage2['default'])(displayCode + '_' + window.utf8Query);
	  var hasHistory = !!storage.get();
	
	  function clearSession() {
	    Object.keys(sessionStorage).filter(function (key) {
	      return key.indexOf(displayCode) !== -1;
	    }).forEach(function (key) {
	      sessionStorage.removeItem(key);
	    });
	  }
	  return {
	    check: function check() {
	      hasHistory && isBackButton ? onBack(storage.get()) : clearSession();
	    },
	
	    storage: storage
	  };
	}
	
	exports['default'] = useTimeMachine;

/***/ },
/* 5 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _jquery = __webpack_require__(1);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	var _clip = __webpack_require__(6);
	
	var _clip2 = _interopRequireDefault(_clip);
	
	var _clipInnerListType = __webpack_require__(7);
	
	var _clipInnerListType2 = _interopRequireDefault(_clipInnerListType);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
	
	/**
	 * vClip 함수의 기본 옵션값
	 * !필독 : $context 의 기본값이 빈 스트링으로 지정되어 있으므로 기입이 되지 않는 다면 문제가 발생 할 수 있습니다.
	 *        반드시 입력받을 것 (변수명의 접두사로 $ 를 가지고 있다면 제이쿼리 객체 이어야 합니다)
	 *        listSelector 의 클래스명이 필요함, (ex 하이라이트 리스트의 ul className)
	 * @type {{$context : string, listSelector : string, itemSelector : string, eventType : string, eventClassName : string,
	 * vclipSelector : string, dataSelector : {date : string, hit : string, vid : string, link : string, desc : string}}}
	 */
	
	/**
	 * vClip 에 동적으로 그려질 템플릿 임폴트
	 * !필독 : - 확장자명은 hbs로 되어있으나, 통검에서는 jsRender 로 그려짐으로 jsRender 로직을 사용하세요.
	 */
	var DEF_OPTS = {
	  $context: '', //필수
	  listSelector: '', //필수
	  itemSelector: 'li',
	  exceptClassName: '_no_vclip', // vclip 이 동작하지 않게 할 아이템의 클래스명
	  eventType: 'click',
	  eventClassName: 'on',
	  removeSelector: '.vclip_sports',
	  vclipSelector: '_vClipBox', // 아이디만 입력, #빼고 명칭만 기입
	  dataSelector: {
	    date: 'date',
	    hit: 'hit',
	    vid: 'vid',
	    link: 'link',
	    desc: 'title'
	  },
	  rendingType: 'basic', // 기본형 외부 랜더링 : basic & 확장됨 리스트내부 랜더링은 inner-list
	  rowCount: 0 // 한 열의 개수
	};
	
	/**
	 * VideoClip 생성자 함수
	 * 용도 : 하이라이트 영상 리스트 클릭시 발동되어 하이라이트 리스트 하단에 선택한 영상을 어팬드 해주는 모듈로 개발 되었습니다.
	 * !필독 : 해당 모듈은 jQuery, jsRender, SF, KTP 가 사용됩니다. 참조 - http://hehet.dev.daum.net
	 */
	function VideoClip(options) {
	  this._options = _jquery2['default'].extend({}, DEF_OPTS, options);
	  this._$context = this._options.$context;
	  this.init();
	}
	
	/**
	 * 하이라이트 리스트에서 영상 아이탬 클릭시 해당 itemSelector 에 eventClassName 를 달아 주는 매서드
	 * (다른 형제 요소들은 eventClassName 제거)
	 * @param $currentItem
	 */
	VideoClip.prototype.onEventClass = function ($currentItem) {
	  $currentItem.addClass(this._options.eventClassName).siblings().removeClass(this._options.eventClassName);
	};
	/**
	 * 하이라이트 리스트에서 영상 아이템 클릭시 해당 itemSelector 에 걸려있는 eventClassName 제거
	 * @param $currentItem
	 */
	VideoClip.prototype.offEventClass = function ($currentItem) {
	  $currentItem.removeClass(this._options.eventClassName);
	};
	/**
	 * kakao tv player 모듈을 로드해 주기 위한 모듈
	 * 로드가 진행 되어야 동영상 재생이 가능합니다.
	 * 참조 - http://hehet.dev.daum.net/modules/outapi/loadModule/kakaotv/index.html
	 */
	VideoClip.prototype.loadKTP = function () {
	  SF.loadModule('kakaotv', function (status, module) {});
	};
	/**
	 * 동적으로 뿌려지는 동영상 영역 (vClip) 의 jsRender 탬플릿에 넘겨줄 데이터를 만들어 줍니다.
	 * 백앤드 개발자와 해당 하는 부분의 데이터를 어떤식으로 전달 받을 것인지 협의가 필요합니다.
	 * 동적인 부분으로 그려저야 할 데이터가 날짜,조회수,동영상 아이디,링크주소,설명 라고 했을경우
	 * 하이라이트 리스트 itemSelector 부분에 data-hit,data-vid,data-link 등으로 전달 받는 것을 가정하고
	 * desc 와 date 부분은 이미 하이라이트 영상 리스트에 노출이 됨으로 해당 부분에서 가져오는것으로 설정 되어 있습니다.
	 * @param $target
	 * @returns {{date, hit : string|*|void, vid, link, desc}}
	 */
	VideoClip.prototype.getVClipData = function ($target) {
	  var dataSelector = this._options.dataSelector;
	  // data 는 data-attr 를 참조하세요
	  var vClipData = {
	    date: $target.data(dataSelector.date),
	    hit: _jquery2['default'].number.addComma($target.data(dataSelector.hit)),
	    vid: $target.data(dataSelector.vid),
	    link: $target.data(dataSelector.link),
	    desc: $target.data(dataSelector.desc)
	  };
	  return vClipData;
	};
	
	/**
	 * jsRender 탬플릿과 getVClipData 를 통해서 지정된 데이터를 listSelector 즉 하이라이트 리스트의
	 * 하단 부분에 붙혀주는 랜딩 메서드 입니다.
	 *
	 * 랜딩 타입이 추가되었습니다. 기본은 basic ( basic, inner-list ) = 현재까지는 두가지 종류가 있습니다.
	 * @param data
	 * @param rendingType
	 * @param rendingIdx
	 */
	VideoClip.prototype.renderVClip = function (data, rendingType, rendingIdx) {
	  var type = rendingType || 'basic';
	  var tmplMap = {
	    'basic': _clip2['default'],
	    'inner-list': _clipInnerListType2['default']
	  };
	  var tmpl = tmplMap[rendingType] || _clip2['default'];
	
	  if (type === 'basic') {
	    var html = _jquery2['default'].templates(tmpl).render(data);
	    this._$context.find(this._options.listSelector).after(html);
	  }
	
	  if (type === 'inner-list') {
	    var _html = _jquery2['default'].templates(tmpl).render(data);
	    var index = rendingIdx || 0;
	    var $targetList = this._$context.find(this._options.listSelector).find(this._options.itemSelector + ('[data-row=\'' + index + '\']'));
	    var $target = $targetList.eq($targetList.length - 1 || 0);
	    $target.after(_html);
	  }
	};
	/**
	 * renderVClip 을 통해서 vClip 의 동적인 부분이 랜딩 되었다면,
	 * KTP 모듈에 해당하는 video-id 를 넘겨서 영상을 생성해 주는 메서드입니다.
	 * 참조 - http://wiki.daumkakao.com/display/keron/Player+IFrame+API
	 * @param selectId
	 * @param vid
	 */
	VideoClip.prototype.createVClip = function (selectId, vid) {
	  var playerContainer = document.getElementById(selectId);
	  var clipLinkId = vid;
	  var profile = 'HIGH';
	  var playerConfig = {
	    type: 'VOD',
	    service: 'daum_searchview',
	    id: clipLinkId + '@my',
	    profile: profile,
	    kakaotv: 0,
	    wmode: 'opaque',
	    fs: 1
	  };
	  var player = KTP.Player.create(playerContainer, playerConfig);
	  player.load(clipLinkId, profile);
	};
	/**
	 * 동적으로 생성된 영역 (vClip) 부분을 제거 하는 메서드 입니다.
	 */
	VideoClip.prototype.removeVClip = function () {
	  this._$context.find('#' + this._options.vclipSelector).parents(this._options.removeSelector).remove();
	};
	/**
	 * 하이라이트 리스트의 이벤트 메서드 입니다.
	 */
	VideoClip.prototype.bindEvents = function () {
	  var that = this;
	  that._$context.find(that._options.listSelector).on(that._options.eventType, that._options.itemSelector, function () {
	    var $this = (0, _jquery2['default'])(this);
	    if ($this.hasClass(that._options.exceptClassName)) {
	      return;
	    }
	    that.removeVClip();
	    if ($this.hasClass(that._options.eventClassName)) {
	      that.offEventClass($this);
	    } else {
	      var clipData = that.getVClipData($this);
	      var vid = $this.data(that._options.dataSelector.vid);
	      that.onEventClass($this);
	      that.renderVClip(clipData, that._options.rendingType, $this.data('row'));
	      that.createVClip(that._options.vclipSelector, vid);
	    }
	  });
	};
	
	/**
	 * data-row 라는 어트리뷰트를 삽입해 주는 함수이다.
	 * rendingType = inner-list 인 상태에서만 사용
	 * rendingType 이 inner-list 라면, 즉 리스트 내부로 클립이 삽입 되는 경우라면
	 * 몇 번째 열 하단에 넣어야 하는지 몇번째 열인지 구분할 필요가 있다.
	 * 여기서 data-row 는 해당하는 열의 가장 마지막에 있는 인덱스를 넣어준다.
	 */
	VideoClip.prototype.setRowData = function () {
	  var that = this;
	  var $targetList = that._$context.find(that._options.listSelector).find(that._options.itemSelector).not('#' + that._options.vclipSelector);
	
	  var rowIdx = 0;
	
	  $targetList.each(function (i, $el) {
	    if (i % that._options.rowCount === 0) {
	      rowIdx += that._options.rowCount - 1;
	    }
	    $el.setAttribute('data-row', rowIdx);
	  });
	};
	/**
	 * 인스턴스 초기화 메서드입니다.
	 */
	VideoClip.prototype.init = function () {
	  this.setRowData();
	  this.loadKTP();
	  this.bindEvents();
	};
	
	exports['default'] = VideoClip;

/***/ },
/* 6 */
/***/ function(module, exports) {

	module.exports = "<div class=\"vclip_sports\"><div class=\"vclip_player\"><div class=\"vclip_box\" id=\"_vClipBox\"></div></div><a href=\"{{:link}}\" class=\"link_item\" target=\"_blank\" title=\"새창열림\"><div class=\"wrap_cont\"> <strong class=\"tit_vclip\">{{:desc}}</strong><div class=\"subinfo_vclip\"> <span class=\"txt_play\"><span class=\"ico_sports ico_video\">재생횟수</span>{{:hit}}</span> <span class=\"txt_date\">{{:date}}</span></div></div></a></div>";

/***/ },
/* 7 */
/***/ function(module, exports) {

	module.exports = "<li class=\"video_player\"><div class=\"vclip_sports\"><div class=\"vclip_player\"><div class=\"vclip_box\" id=\"_vClipBox_list\"></div></div><a href=\"{{:link}}\" class=\"link_item\" target=\"_blank\" title=\"새창열림\"><div class=\"wrap_cont\"> <strong class=\"tit_vclip\">{{:desc}}</strong><div class=\"subinfo_vclip\"> <span class=\"txt_play\"><span class=\"ico_sports ico_video\">재생횟수</span>{{:hit}}</span> <span class=\"txt_date\">{{:date}}</span></div></div></a></div></li>";

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** sports/sports-EPT.bundle.06fe9ce.js
 **/